import { Headers, RequestOptions, ResponseContentType } from '@angular/http';
var JWT = /** @class */ (function () {
    function JWT() {
    }
    JWT.jwtToken = function () {
        var currentUser = localStorage.getItem('authorization');
        return currentUser;
    };
    JWT.jwt = function () {
        var currentUser = localStorage.getItem('authorization');
        if (currentUser) {
            //alert('creating headers with jwtToken='+currentUser);
            var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': currentUser });
            //alert('creating headers='+headers);
            return new RequestOptions({ headers: headers });
        }
    };
    JWT.jwtDelete = function (bodyObj) {
        var currentUser = localStorage.getItem('authorization');
        if (currentUser) {
            //alert('creating headers with jwtToken='+currentUser);
            var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': currentUser });
            //alert('creating headers='+headers);
            return new RequestOptions({ headers: headers, body: bodyObj });
        }
    };
    JWT.jwtDoc = function () {
        var currentUser = localStorage.getItem('authorization');
        if (currentUser) {
            var headers = new Headers({ 'Authorization': currentUser });
            return new RequestOptions({ headers: headers, responseType: ResponseContentType.ArrayBuffer });
        }
    };
    JWT.jwtImg = function () {
        var currentUser = localStorage.getItem('authorization');
        if (currentUser) {
            var headers = new Headers({ 'Authorization': currentUser });
            return new RequestOptions({ headers: headers });
        }
    };
    JWT.signupJwt = function () {
        var headers = new Headers({ 'Content-Type': 'application/json' });
        return new RequestOptions({ headers: headers });
    };
    return JWT;
}());
export { JWT };
//# sourceMappingURL=jwt.js.map